// extracted by mini-css-extract-plugin
export default {"modal":"popup_modal__0AjJV","title":"popup_title__VM7kW","content":"popup_content__6XYnn","close":"popup_close__-k2oG","icon":"popup_icon__9KMLv","square":"popup_square__RuUHt"};